import React from "react";
import { useRoutes } from "react-router-dom";
import Home from "pages/Home";
import NotFound from "pages/NotFound";
import Thumbnail from "pages/Thumbnail";

const ProjectRoutes = () => {
  let element = useRoutes([
    // { path: "/", element: <Home /> },
    { path: "*", element: <NotFound /> },
    {
      path: "/",
      element: <Thumbnail />,
    },
  ]);

  return element;
};

export default ProjectRoutes;
